<template>
	<div class="counter" :class="{
		'counter--big': big,
		'counter--small': small,
		'counter--mini': mini,
	}">
		<button class="counter__btn" :class="{
			'counter__btn--big': big,
			'counter__btn--small': small,
			'counter__btn--mini': mini,
		}" @click.stop="changeValue(-1)">
			<img class="counter__btn-minus" src="@/assets/img/minus.svg" alt="Minus" />
		</button>
		<div
			v-if="!hasInput"
			class="counter__value"
			:class="{
				'counter__value--big': big,
				'counter__value--small': small,
				'counter__value--mini': mini,
			}"
		>
			{{ counter }}
		</div>
		<input
			v-else
			class="counter__value"
			v-model="counter"
			type="number"
			:min="min"
			:max="max"
			:class="{
				'counter__value--big': big,
				'counter__value--small': small,
				'counter__value--mini': mini,
			}"
			@input="handleInput"
		>
		<button class="counter__btn" :class="{
			'counter__btn--big': big,
			'counter__btn--small': small,
			'counter__btn--mini': mini,
		}" @click.stop="changeValue(1)">
			<img class="counter__btn-plus" src="@/assets/img/plus.svg" alt="Plus" v-if="uiColor == 'green'">
			<img class="counter__btn-plus" src="@/assets/img/plusBlue.svg" alt="Plus" v-else>
		</button>
	</div>
</template>

<script>
import { mapMutations } from "vuex";
import debounce from "lodash/debounce";

export default {
	name: "Counter",
	data() {
		return {
			counter: 0,
			oldCounter: null,
		};
	},
	props: {
		checkCounterBetweenChange : { type: Function, default: () => true },
		canChange : { type: Boolean, default: true },
		hasInput  : { type: Boolean, default: false },
		uiColor   : { type: String,  default: 'green' },
		value     : { type: Number,  default: 0 },
		small     : { type: Boolean, default: false },
		mini      : { type: Boolean, default: false },
		min       : { type: Number,  default: 0 },
		max       : { type: Number,  default: 99 },
		big       : { type: Boolean, default: false },
	},
	methods: {
		...mapMutations({
			setCartLoading: 'setCartLoading',
		}),
		checkCounterBetweenMinAndMax() {
			return this.counter >= this.min && this.counter <= this.max;
		},
		handleInput($event) {
			let value = Number($event.target.value);
			
			if (value > this.max)
				value = this.max;
			
			this.counter = Number(value);
			
			if (value == this.oldCounter)
				return;

			this.oldCounter = this.counter;

			if (!this.canChange || !this.checkCounterBetweenMinAndMax() || !this.checkCounterBetweenChange())
				return (this.counter = this.oldCounter);

			this.changeCounter();
		},
		changeValue(value) {
			this.oldCounter = this.counter;
			this.counter += value;

			if (!this.canChange || !this.checkCounterBetweenMinAndMax() || !this.checkCounterBetweenChange())
				return (this.counter = this.oldCounter);

			this.changeCounter();
		},
		changeCounter() {
			if (this.debounceTimer)
				clearTimeout(this.debounceTimer);

			const delay = this.counter === 0 ? 5000 : 500;

			this.debounceTimer = setTimeout(() => {
				if (this.$route.path === '/menu')
					this.setCartLoading(true);

				this.$emit("change", this.counter);
			}, delay);
		},
	},
	watch: {
		value() {
			this.counter = this.value || 0;
		},
	},
	mounted() {
		this.counter = this.value || 0;
	}
}
</script>

<style lang="scss">
.counter {
	min-width: 112px;
	height: 36px;
	border-radius: 8px;
	background: $greyBackground;
	border: 2px solid $greyBorder;
	display: flex;
	justify-content: space-between;
	align-items: center;
	overflow: hidden;
	padding: 0 1px;

	&--big { height: 56px }
	
	&--small { height: 40px }
	
	&--mini { height: 36px }
}

.counter__btn {
	background: #fff;
	width: 30px;
	height: 30px;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);

	&--big {
		height: 48px;
		width: 48px;
	}

	&--small {
		height: 34px;
		width: 34px;
	}

	&--mini {
		height: 30px;
		width: 30px;
	}
}

.counter__btn-minus {
	width: 20px;
	height: 20px;
}

.counter__btn-plus {
	width: 17px;
	height: 17px;
}

.counter__value {
	max-width: 24px;
	text-align: center;
	border: none;
	background-color: transparent;
	padding: 0;
	font-size: 16px;
	font-family: $mainFontBoldNew;
	color: $textColor;
  -moz-appearance: textfield;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	  margin: 0;
	}

	&--big { font-size: 18px }

	&--small { font-size: 14px }

	&--mini { font-size: 14px }
}
</style>